// @flow

const selectQueryPolicies = {
  errorPolicy: 'all',
  fetchPolicy: 'network-only'
};

export default selectQueryPolicies;
